export function isEmpty(value: any): boolean {
  return !value || (typeof value === 'string' && value.trim() === '');
}

export function isNumberEmpty(value: number | null | undefined): boolean {
  return !(value || value === 0);
}

export const isNullOrEmpty = (_array: any[]) => {
  return _array === null || _array === undefined || _array.length <= 0;
};

export const isDevEnvironment = process.env.NODE_ENV === 'development';

export const hasAnyNull = (values: unknown[]): boolean => {
  let result = false;
  if (!isNullOrEmpty(values)) {
    result = values.some(item => item === null);
  }
  return result;
};
